import editorModel from '../data/editorModel';
var SITE_GENERATION_TEMPLATE_ID = 'd2edaaf7-274a-4f0b-9468-67313dac43cb';
export var isSiteGenerationTemplate = function () {
    var originalTemplateId = editorModel.siteHeader.originalTemplateId;
    return originalTemplateId === SITE_GENERATION_TEMPLATE_ID;
};
